import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { MyCalOption } from '../../types/my-calendar.type';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-my-calendar-show-options',
  templateUrl: './my-calendar-show-options.component.html',
  styleUrls: ['./my-calendar-show-options.component.scss'],
})
export class MyCalendarShowOptionsComponent implements OnChanges {
  @Input()
  public showOptions: MyCalOption[] = [];

  public innerForm: FormGroup;

  @Output() myCalendarShowOptionsChanged = new EventEmitter();

  ngOnChanges(): void {
    const formControls: Record<string, FormControl> = {};

    this.showOptions.forEach((option) => {
      formControls[option.key] = new FormControl(option.is_selected, {});
    });

    this.innerForm = new FormGroup(formControls);

    this.innerForm.valueChanges.subscribe((formData) => {
      this.myCalendarShowOptionsChanged.emit(formData);
    });
  }
}
